// extracted by mini-css-extract-plugin
export default {"footer":"Main_footer__NfTCh"};